module.exports = __webpack_public_path__ + "static/img/img_0.e86b7d4a.png";